import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "Button/Button";
import Input from "components/Input/Input";
import { useState } from "react";
import "./FileInput.scss";
import { DocumentTypes } from "constants/UserConstants";
function FileInput(props) {
  const {
    onFileChange,
    onFileNameUpdate,
    onFileTypeUpdate,
    maxFileSizeInMB,
    fileNameValue,
    allowNameEdit,
  } = props;

  const hiddenFileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const onFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!isFileValid(file)) {
      alert(`Max allowed file size is ${maxFileSizeInMB}MB`);
      return;
    }
    setFile(file);
    onFileChange(e.target.files);
    const fileNameWithoutFormat = getFileNameWithoutFormat(file.name);
    if (!fileName) {
      setFileName(fileNameWithoutFormat);
      onFileNameUpdate(fileNameWithoutFormat);
    }
  };

  const onUploadClick = (e) => {
    e.preventDefault();
    const inputFileElement = hiddenFileInputRef.current;
    inputFileElement.click();
  };

  const onFileNameChange = (e) => {
    setFileName(e.target.value);
    onFileNameUpdate(e.target.value);
  };

  const onDocumentTypeChange = (e) => {
    onFileTypeUpdate(e.target.value);
  };

  const isFileValid = (file) => {
    const maxSizeLimit = maxFileSizeInMB * 1024 * 1000;
    return file.size < maxSizeLimit;
  };

  const getFileNameWithoutFormat = (name) => {
    const nameArr = name.split(".");
    if (nameArr.length) {
      return nameArr[0];
    }
    return name;
  };

  useEffect(() => {
    setFileName(fileNameValue);
  }, [fileNameValue]);

  return (
    <div className="file-input">
      <label className="file-input-ctr" for="file-upload">
        <div className="input-with-file-size">
          <Input
            className="file-name-changer"
            placeholder="Please select a file"
            value={fileName}
            onChange={onFileNameChange}
            readOnly={!Boolean(file) && !allowNameEdit}
          />
          <div className="file-size-info">{`*max.file size ${maxFileSizeInMB}MB`}</div>

          <label for="documentTypeSelector" className="documentType-label">Select Option </label>
          <select name="documentTypeSelector" id="documentTypeSelect" onChange={onDocumentTypeChange} className="documentType-options">
            {DocumentTypes.map((option) => (
              <option value={option.value}>{option.title}</option>
            ))}
          </select>
        </div>
        <Button label="Upload" onClick={onUploadClick} />
      </label>

      <input
        className="d-none"
        ref={hiddenFileInputRef}
        type="file"
        onChange={onFileInputChange}
        id="file-upload"
      />
    </div>
  );
}

FileInput.propTypes = {
  onFileChange: PropTypes.func.isRequired,
  onFileNameUpdate: PropTypes.func.isRequired,
  maxFileSizeInMB: PropTypes.number,
  fileNameValue: PropTypes.string,
  onFileTypeUpdate: PropTypes.func.isRequired,
  allowNameEdit: PropTypes.bool,
};

FileInput.defaultProps = {
  maxFileSizeInMB: 50,
  fileNameValue: "",
  allowNameEdit: false,
};

export default FileInput;
